import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../style/CookieConsent.module.css';
import { useCookie } from '../context/CookieContext';

const CookieConsent = () => {
  const { consent, acceptCookies, declineCookies } = useCookie();

  // If the user has already decided (accepted or declined), hide the banner
  if (consent === 'accepted' || consent === 'declined') {
    return null;
  }

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <p style={{ margin: 0 }}>
          <strong>Datenschutzhinweis:</strong> Wir nutzen Cookies und ähnliche Technologien, 
          um Ihr Nutzererlebnis auf unserer Website zu optimieren und Ihnen personalisierte Inhalte bereitzustellen. 
          Durch Klicken auf "Akzeptieren" stimmen Sie der Verarbeitung Ihrer Daten gemäß unserer 
          <Link to="/datenschutz" className={styles.link}>Datenschutzerklärung</Link> zu.
        </p>
      </div>
      <div className={styles.buttonGroup}>
        <button onClick={declineCookies} className={styles.declineBtn}>
          Ablehnen
        </button>
        <button onClick={acceptCookies} className={styles.acceptBtn}>
          Akzeptieren
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;